import React from 'react';
import * as Sentry from '@sentry/react';

interface OverseaPageErrorBoundaryProps {
  children: React.ReactNode;
}

interface OverseaPageErrorBoundaryState {
  hasError: boolean;
}

/** 海外首页发生客户端渲染异常时保留可索引、可导航的最小静态内容。 */
export default class OverseaPageErrorBoundary extends React.Component<
OverseaPageErrorBoundaryProps,
OverseaPageErrorBoundaryState
> {
  /** 初始化边界状态，默认继续渲染真实海外首页。 */
  constructor(props: OverseaPageErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  /** 将子树异常切换为静态 fallback，避免 Next.js 接管整个页面显示 Application Error。 */
  static getDerivedStateFromError(): OverseaPageErrorBoundaryState {
    return { hasError: true };
  }

  /** 上报组件栈，且监控 SDK 自身失败时仍保持 fallback 可渲染。 */
  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    try {
      Sentry.captureException(error, {
        tags: {
          app: 'oversea',
          lifecycle: 'render',
          stage: 'oversea/pageErrorBoundary',
        },
        extra: {
          componentStack: errorInfo.componentStack,
        },
      });
    } catch (reportError) {
      console.error('[Oversea] ErrorBoundary report failed:', reportError);
    }
  }

  /** 正常展示海外应用；异常后仅使用原生元素输出稳定的首页基础信息。 */
  render(): React.ReactNode {
    const { hasError } = this.state;
    const { children } = this.props;
    if (!hasError) {
      return children;
    }

    return (
      <main
        style={{
          alignItems: 'center',
          background: '#0a0a0a',
          color: '#fff',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          minHeight: '100vh',
          padding: '32px',
          textAlign: 'center',
        }}
      >
        <h1>RoboNeo</h1>
        <p>AI Creative Agent for images, videos, and more.</p>
        <p>Create stunning visuals and videos with AI-powered creative tools.</p>
        <a href="/" style={{ color: '#c77dff' }}>Return to RoboNeo</a>
      </main>
    );
  }
}
